var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import { ReactComponent as ArrowDown } from "./../../assets/icons/arrow-down.svg";
import { ReactComponent as TopLeagues } from "./../../assets/icons/top-leagues.svg";
import { ReactComponent as Countries } from "./../../assets/icons/flag.svg";
import { ReactComponent as National } from "./../../assets/icons/national-teams.svg";
import { ReactComponent as International } from "./../../assets/icons/international.svg";
import messages from "../../i18n/messages";
import { detectPreferredLocale } from "../../utils/locale";
const filterItems = (items) => items.filter((item) => item.isVisible);
const locale = detectPreferredLocale();
const TOP_LEVEL_ITEM_INFO = {
  Popular: {
    msgKey: "top_leagues",
    icon: /* @__PURE__ */ jsx(TopLeagues, {})
  },
  Countries: {
    msgKey: "countries",
    icon: /* @__PURE__ */ jsx(Countries, {})
  },
  "National Teams": {
    msgKey: "national_teams",
    icon: /* @__PURE__ */ jsx(National, {})
  },
  "Clubs International": {
    msgKey: "club_international",
    icon: /* @__PURE__ */ jsx(International, {})
  }
};
const renderExpandIcon = ({ isOpen }) => /* @__PURE__ */ jsx(
  ArrowDown,
  {
    className: `left-tree-arrow stroke-base${isOpen ? " left-tree-arrow--open" : ""}`
  }
);
const getItemIcon = (item, depth) => {
  var _a, _b;
  const iconType = depth > 1 ? "small" : ((_a = item.children) == null ? void 0 : _a.length) ? "country" : "league";
  return /* @__PURE__ */ jsx("span", { className: `left-tree-icon left-tree-icon--${iconType}`, children: ((_b = item.data) == null ? void 0 : _b.imagePath) ? /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx("img", { src: item.data.imagePath, alt: "", loading: "lazy" }) }) : null });
};
const mapDataToMenuItems = ({ children, parentKey, depth = 0 }) => {
  const menuItems = filterItems(children).map((item, index) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    const key = parentKey ? `${parentKey}-${index}` : `${index}`;
    return {
      key,
      expandIcon: parentKey ? renderExpandIcon : null,
      "data-key": key,
      label: !parentKey ? (messages[locale] && TOP_LEVEL_ITEM_INFO[(_a = item.data) == null ? void 0 : _a.text] ? messages[locale][TOP_LEVEL_ITEM_INFO[(_b = item.data) == null ? void 0 : _b.text].msgKey] : ((_d = TOP_LEVEL_ITEM_INFO[(_c = item.data) == null ? void 0 : _c.text]) == null ? void 0 : _d.msgKey) && messages[locale] ? messages[locale][TOP_LEVEL_ITEM_INFO[(_e = item.data) == null ? void 0 : _e.text].msgKey] : (_f = item.data) == null ? void 0 : _f.text) || ((_g = item.data) == null ? void 0 : _g.text) : (_h = item.data) == null ? void 0 : _h.name,
      id: (_i = item.data) == null ? void 0 : _i.id,
      icon: !parentKey ? (_k = TOP_LEVEL_ITEM_INFO[(_j = item.data) == null ? void 0 : _j.text]) == null ? void 0 : _k.icon : getItemIcon(item, depth),
      children: ((_l = item.children) == null ? void 0 : _l.length) ? mapDataToMenuItems({
        children: item.children || [],
        parentKey: key,
        depth: depth + 1
      }) : null
    };
  });
  return menuItems;
};
const filterMenu = (items, search) => {
  if (!search)
    return items;
  return items.map((item) => {
    if (item.children) {
      const filteredChildren = filterMenu(item.children, search);
      if (filteredChildren.length) {
        return __spreadProps(__spreadValues({}, item), { children: filteredChildren });
      }
    }
    if ([item.label, item.countryName].some(
      (itemString) => itemString == null ? void 0 : itemString.toLowerCase().includes(search.toLowerCase())
    )) {
      return item;
    }
    return null;
  }).filter(Boolean);
};
export {
  filterMenu,
  mapDataToMenuItems
};
